import WithUnit from '@components/WithUnit';
import { Text, View } from '@react-pdf/renderer';
import { getRatingCSSColor } from '@utils/rating';
import { round } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { Column } from '../../../columns/createColumn';
import { ValidUnit } from '../../../constants/units';
import ProgressBar from '../components/ProgressBar';
import ProgressTitle from '../components/ProgressTitle';
import ForesightedDrivingIcon from './ForesightedDrivingIcon';

const ForesightedDrivingTitleBar = ({ title, value }: { title: Column; value: number | null | undefined }) => {
    const ratingColor = getRatingCSSColor(value).hexColor;
    const progressTitleValue = <WithUnit unit={ValidUnit.PERCENTAGE}>{round(value || 0)}</WithUnit>;
    return (
        <View style={{ flexDirection: 'row' }}>
            <View
                style={{
                    textAlign: 'left',
                    flexDirection: 'row',
                    width: '25%',
                }}
            >
                <ForesightedDrivingIcon id={title.key} />
                <Text style={{ fontFamily: 'Bold' }}>
                    <FormattedMessage id={title.labelId} />
                </Text>
            </View>

            <View
                style={{
                    height: 10,
                    width: '60%',
                    marginTop: 1,
                    marginRight: 10,
                }}
            >
                <ProgressBar color={ratingColor} progress={value || 0} />
            </View>
            <ProgressTitle color={ratingColor} value={progressTitleValue} />
        </View>
    );
};

export default ForesightedDrivingTitleBar;
